import axios from '@/utils/axios'
// 获取导航列表
export const getNavList = () => axios({
  url: '/api/getNavList',
  method: 'get'
})

// 根据参数获取页面数据
export const getPageDetail = (pageType, id) => axios({
  url: '/api/getPageDetail?pageType=' + pageType + '&id=' + id,
  method: 'get'
})

export const getStoreDetails = (id) => axios({
  url: '/api/getStoreDetails?id=' + id,
  method: 'get'
})

// 提交意見
export const addContent = (obj) => axios({
  url: '/api/addContent',
  method: 'POST',
  data: obj
})

// 搜索
export const search = (keyWord) => axios({
  url: '/api/search?keyWord=' + keyWord,
  method: 'get'
})

// 密码
export const confirmPassword = (username, password) => axios({
  url: '/passwordtable/check?username=' + username + '&password=' + password,
  method: 'get'
})
